// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import {
  injectSheet,
  type InjectSheetProvidedProps,
  type ThemeType
} from '@catalytic/catalytic-ui';

import { ROOT as ROOT_PATH } from '../const/path';

import logoUrl from '../images/logo.svg';

export const Style = (theme: ThemeType) => ({
  root: {
    padding: '1rem 0 1.75rem',
    width: '100%',
    zIndex: theme.zIndex.nav,
    backgroundColor: theme.colors.white,
    [theme.breakpoints.gt.mobile.portrait]: {
      padding: '1rem 0 0.5rem'
    }
  },
  image: {
    height: '4rem',
    width: '100%',
    marginTop: '.5rem',
    [theme.breakpoints.tablet]: {
      height: '5rem',
      marginTop: '1.5rem'
    }
  },
  logo: {
    width: '16rem'
  }
});

type Props = InjectSheetProvidedProps & {
  hasFullHeader: boolean
};

export const LoginHeader = ({ classes }: Props) => {
  return (
    <Link to={ROOT_PATH}>
      <header className={classes.root}>
        <div className={classes.logo}>
          <img
            className={classes.image}
            data-testid="login-logo"
            src={logoUrl}
            alt="PagerDuty Workflow Automation"
          />
        </div>
      </header>
    </Link>
  );
};
LoginHeader.displayName = 'LoginHeader';

export default injectSheet(Style)(LoginHeader);
